/* eslint-disable no-restricted-syntax */
import { GetStaticProps } from 'next';
import Head from 'next/head';
import { ReactElement } from 'react';

import { StandardLayout } from '@components/Layouts';
import { Paragraph, TextLink } from '@components/Typography';
import { sanityFetch } from '@lib/sanity.fetch';

// const MainStyle = styled.main`
//   padding-top: 105px;
//   padding-bottom: 350px;
//   --margin-horizontal: 300px;

//   @media (max-width: 1000px) {
//     --margin-horizontal: 200px;
//   }
//   @media (max-width: 800px) {
//     --margin-horizontal: 100px;
//   }
//   @media (max-width: 600px) {
//     --margin-horizontal: 20px;
//   }
// `;

interface Article {
  date: string;
  slug: string;
  summary: string;
  title: string;
}

function Article({ article }: { article: Article }) {
  return (
    <article className="grid grid-cols-1 gap-12.5">
      <div>
        <h2>{article.title}</h2>
        <>{article.date}</>
        <Paragraph>{article.summary}</Paragraph>
        <TextLink className="font-bold" href={article.slug}>
          Read more
        </TextLink>
      </div>
    </article>
  );
}

export default function ArticlesPage({ articles }: { articles: Article[] }) {
  return (
    <>
      <Head>
        <title>
          Criminal Law Articles Tasmania | Legal Guides Hobart | Monk Lawyers
        </title>
        <meta
          name="title"
          content="Criminal Law Articles Tasmania | Legal Guides Hobart | Monk Lawyers"
          key="metatitle"
        />
        <meta
          name="description"
          content="Summaries of articles written by Monk Lawyers regarding different aspects of Tasmanian Criminal Law"
          key="metadescription"
        />
      </Head>

      <main className="bg-cream text-blue container pt-[105px] pb-[350px]">
        <h1>Articles</h1>

        <section className="flex flex-col gap-[60px]">
          {articles.map((a) => (
            <Article key={a.slug} article={a} />
          ))}
        </section>
      </main>
    </>
  );
}

ArticlesPage.getLayout = function getLayout(page: ReactElement) {
  return <StandardLayout>{page}</StandardLayout>;
};

export const getStaticProps: GetStaticProps = async ({
  params,
  draftMode = false,
}) => {
  const articles = await sanityFetch<Article[]>({
    draftMode,
    query: `//groq
      *[_type == "article" && !(_id in path("drafts.**"))]
      {
        title,
        date,
        summary,
        "slug": slug.current
      }
      `,
  });

  return {
    props: {
      articles,
    },
  };
};
